
<section class="position-relative py-5 py-md-6">
    <div class="container pb-0 pt-0">
        <div class="row align-items-center g-4">
            <div class="col-lg-5 col-md-6">
                <img src="../../../../assets/images/new-images/22slider-bg.jpg" class=" img-fluid" />
            </div>

            <div class="col-lg-7 col-md-6 mt-5 mt-md-0">
                <div class="ms-lg-5">
                    <h3 class="mb-4 display-6 fw-semibold">Millions of jobs. <br> Find the one that's right for you.
                    </h3>
                    <p class="text-muted mb-4">Search all the open positions on the web. Get your own personalized
                        salary estimate. Read reviews on over 30000+ companies worldwide.</p>

                    <ul class="list-unstyled text-muted">
                        <li class="mb-2 d-flex align-items-center">

                            <i class="bi bi-check-circle text-emerald-600 fs-5 me-2"></i>
                            Digital Marketing Solutions for Tomorrow
                        </li>
                        <li class="mb-2 d-flex align-items-center">
                            <i class="bi bi-check-circle text-emerald-600 fs-5 me-2"></i>
                            Our Talented & Experienced Marketing Agency
                        </li>
                        <li class="mb-2 d-flex align-items-center">
                            <i class="bi bi-check-circle text-emerald-600 fs-5 me-2"></i>
                            Create your own skin to match your brand
                        </li>
                    </ul>

                    <div class="mt-4">
                        <a href="#" class="btn btn-outline-primary px-5 py-2">
                            <i class="mdi mdi-email-outline me-2"></i> Known More
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>


</section>


<section>

    <div class="container pt-0 pb-0">
        <div class="row">
            <div class="col-xl-12">
                <h3 class="fw-bold">Popular Categories </h3>
            </div>
        </div>
    </div>

    <div class="container py-4 popularjobs">
        <div class="row g-4">
            <!-- Business Development -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Business Development</a>
                        </h5>
                        <p class="text-muted mb-0">74 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Marketing & Communication -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Marketing &amp;
                                Communication</a>
                        </h5>
                        <p class="text-muted mb-0">20 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Project Management -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Project Management</a>
                        </h5>
                        <p class="text-muted mb-0">35 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Customer Service -->


            <!-- Software Engineering -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Software Engineering</a>
                        </h5>
                        <p class="text-muted mb-0">60 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Human Resource HR -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Human Resource HR</a>
                        </h5>
                        <p class="text-muted mb-0">74 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- IT & Networking -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">It &amp; Networking</a>
                        </h5>
                        <p class="text-muted mb-0">35 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Sales & Marketing -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Sales &amp; Marketing</a>
                        </h5>
                        <p class="text-muted mb-0">35 Jobs</p>
                    </div>
                </div>
            </div>

            <!-- Data Science -->
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <div class="card text-center h-100">
                    <div class="card-body d-flex flex-column align-items-center justify-content-center">
                        <div class="bg-success bg-opacity-10 text-success rounded-circle p-3 mb-3">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"
                                height="1.5em" width="1.5em">
                                <!-- SVG Path here -->
                            </svg>
                        </div>
                        <h5 class="card-title">
                            <a href="/job-categories" class="text-decoration-none text-dark">Data Science</a>
                        </h5>
                        <p class="text-muted mb-0">60 Jobs</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

</section>
<section class="recent-job-area bg-color-gray">
    <div class="container aos-init aos-animate" data-aos="fade-down">
        <div class="row">
            <div class="col-12">
                <div class="section-title text-center">
                    <h3 class="title">Popular Jobs</h3>
                    <div class="desc">
                        <p>Many desktop publishing packages and web page editors</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <!--== Start Recent Job Item ==-->

                <div class="recent-job-item p-3">
                    <div class="company-info card-body">
                        <div class="logo">
                            <a href="company-details.html"><img
                                    src="../../../../assets/images/new-images/OUK_Logo 1.png" width="75" height="75"
                                    alt="Image-HasTech"></a>
                        </div>
                        <div class="content">
                            <h4 class="name"><a href="company-details.html">Darkento Ltd.</a></h4>
                            <p class="address">New York, USA</p>
                        </div>
                    </div>
                    <div class="main-content">
                        <h3 class="title"><a href="job-details.html">Front-end Developer</a></h3>
                        <h5 class="work-type">Full-time</h5>
                        <p class="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p>
                    </div>
                    <div class="recent-job-info">
                        <div class="salary">
                            <h4>$5000</h4>
                            <p>/monthly</p>
                        </div>
                        <a class="btn-theme btn-sm" href="job-details.html">Apply Now</a>
                    </div>
                </div>
                <!--== End Recent Job Item ==-->
            </div>
            <div class="col-md-6 col-lg-4">
                <!--== Start Recent Job Item ==-->

                <div class="recent-job-item p-3">
                    <div class="company-info card-body">
                        <div class="logo">
                            <a href="company-details.html"><img
                                    src="../../../../assets/images/new-images/OUK_Logo 1.png" width="75" height="75"
                                    alt="Image-HasTech"></a>
                        </div>
                        <div class="content">
                            <h4 class="name"><a href="company-details.html">Darkento Ltd.</a></h4>
                            <p class="address">New York, USA</p>
                        </div>
                    </div>
                    <div class="main-content">
                        <h3 class="title"><a href="job-details.html">Front-end Developer</a></h3>
                        <h5 class="work-type">Full-time</h5>
                        <p class="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p>
                    </div>
                    <div class="recent-job-info">
                        <div class="salary">
                            <h4>$5000</h4>
                            <p>/monthly</p>
                        </div>
                        <a class="btn-theme btn-sm" href="job-details.html">Apply Now</a>
                    </div>
                </div>
                <!--== End Recent Job Item ==-->
            </div>
            <div class="col-md-6 col-lg-4">
                <!--== Start Recent Job Item ==-->

                <div class="recent-job-item p-3">
                    <div class="company-info card-body">
                        <div class="logo">
                            <a href="company-details.html"><img
                                    src="../../../../assets/images/new-images/OUK_Logo 1.png" width="75" height="75"
                                    alt="Image-HasTech"></a>
                        </div>
                        <div class="content">
                            <h4 class="name"><a href="company-details.html">Darkento Ltd.</a></h4>
                            <p class="address">New York, USA</p>
                        </div>
                    </div>
                    <div class="main-content">
                        <h3 class="title"><a href="job-details.html">Front-end Developer</a></h3>
                        <h5 class="work-type">Full-time</h5>
                        <p class="desc">CSS3, HTML5, Javascript, Bootstrap, Jquery</p>
                    </div>
                    <div class="recent-job-info">
                        <div class="salary">
                            <h4>$5000</h4>
                            <p>/monthly</p>
                        </div>
                        <a class="btn-theme btn-sm" href="job-details.html">Apply Now</a>
                    </div>
                </div>
                <!--== End Recent Job Item ==-->
            </div>


        </div>
    </div>
</section>